export default (to, from, savedPosition) =>
  new Promise(resolve => {
    // TODO: Spec
    setTimeout(() => {
      // Modal open / close: hold the current scroll so the lock's restore isn't overwritten
      if (to?.hash || from?.hash)
        return resolve({ x: window.scrollX, y: window.scrollY })

      if (to?.path === from?.path) return resolve({}) // Same page

      if (to && to.query?.download) return resolve({}) // Don't change scroll pos

      if (savedPosition) return resolve(savedPosition)

      return resolve({ x: 0, y: 1 }) // 1px to prevent iOS from showing Safari window
    }, 200)
  })
